/**
 * Get CSRF token from cookies
 * Django uses 'csrftoken' cookie name by default
 */
export function getCsrfToken() {
  const name = 'csrftoken';
  let cookieValue = null;
  
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  
  return cookieValue;
}

/**
 * Get headers with CSRF token for fetch requests
 */
export function getCsrfHeaders() {
  const csrfToken = getCsrfToken();
  return csrfToken ? { 'X-CSRFToken': csrfToken } : {};
}
